<template>
  <Listbox :model-value="modelValue" multiple @update:model-value="emit('update:modelValue', $event)">
    <div class="relative">
      <ListboxButton class="select flex w-44 items-center justify-between gap-2 text-left">
        <span class="truncate" :class="{ 'text-gray-400': modelValue.length === 0 }">{{ triggerLabel }}</span>
        <span class="text-[10px] text-gray-400" aria-hidden="true">▼</span>
      </ListboxButton>

      <ListboxOptions class="absolute left-0 top-full z-50 mt-1 w-72 rounded-md border border-gray-200 bg-white py-1 shadow-lg focus:outline-none">
        <ListboxOption v-for="option in options" :key="option.code" v-slot="{ active, selected }" :value="option.code" as="template">
          <li class="flex cursor-pointer items-start gap-2 px-3 py-1.5" :class="{ 'bg-gray-50': active }">
            <input type="checkbox" class="pointer-events-none mt-0.5" :checked="selected" tabindex="-1" aria-hidden="true" />
            <span class="min-w-0">
              <span class="block text-sm font-medium text-gray-900">{{ option.code }}</span>
              <span v-if="option.name && option.name !== option.code" class="block truncate text-xs text-gray-400">{{ option.name }}</span>
            </span>
          </li>
        </ListboxOption>
        <button
          v-if="modelValue.length > 0"
          type="button"
          class="mt-1 w-full border-t border-gray-100 px-3 py-1.5 text-left text-xs text-blue-700 hover:bg-gray-50"
          @click="emit('update:modelValue', [])"
        >
          Clear — show all vendors
        </button>
      </ListboxOptions>
    </div>
  </Listbox>
</template>

<script setup lang="ts">
  import { Listbox, ListboxButton, ListboxOption, ListboxOptions } from '@headlessui/vue';
  import { computed } from 'vue';

  const MAX_LISTED_ALIASES = 2;

  const props = defineProps<{
    modelValue: string[];
    options: { code: string; name: string }[];
  }>();

  const emit = defineEmits<{ 'update:modelValue': [value: string[]] }>();

  const triggerLabel = computed(() => {
    if (props.modelValue.length === 0) return 'All vendors';
    if (props.modelValue.length <= MAX_LISTED_ALIASES) return props.modelValue.join(', ');
    return `${props.modelValue.length} vendors`;
  });
</script>
